document.addEventListener("DOMContentLoaded", function () {
  const printButtons = document.querySelectorAll(".print_bip");

  printButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const nid = this.getAttribute("data-nid");

      fetch(`/node/${nid}?_format=html`)
        .then((response) => response.text())
        .then((content) => {
          const printWindow = window.open("", "_blank", "width=800,height=600");
          printWindow.document.write("<html><head><title>Print Node</title>");
          printWindow.document.write(
            '<link rel="stylesheet" type="text/css" href="/path/to/your/css/print.css">'
          );
          printWindow.document.write("</head><body>");
          printWindow.document.write(content);
          printWindow.document.write("</body></html>");
          printWindow.document.close();
          printWindow.print();
        })
        .catch((error) => {
          console.error("Error fetching node content:", error);
          alert("Error fetching node content. Please try again later.");
        });
    });
  });
});
